import _padLeft from 'lodash/padStart';
import Modernizr from 'modernizr';
import React from 'react';
import SelectInput from './SelectInput.js';
import './DateInput.css';

class DateInput extends React.Component {
  static defaultProps = function () {
    const now = new Date();
    const year = now.getFullYear();
    return {
      forceFallback: false,
      min: '1900-01-01',
      minYearFirst: false,
      max: `${year + 10}-01-01`,
      required: false,
    };
  }();

  componentWillReceiveProps(nextProps) {
    if (!nextProps.value) {
      return;
    }
    this.setState(this._parseValue(nextProps.value));
  }

  _parseValue = (value) => {
    if (value) {
      const parts = value.split('-');
      if (parts.length === 3) {
        const d = new Date(parseInt(parts[0], 10), parseInt(parts[1], 10)-1, parseInt(parts[2], 10));
        if (!isNaN(d.getTime())) {
          return {
            year: _padLeft(String(d.getFullYear()), 4, '0'),
            month: _padLeft(String(d.getMonth() + 1), 2, '0'),
            day: _padLeft(String(d.getDate()), 2, '0'),
          };
        }

      }
    }
    return {
      year: '',
      month: '',
      day: '',
    };
  };

  _onDayChanged = (event) => {
    this.setState({day: event.target.value}, this._onPolyfillChanged);
  };

  _onMonthChanged = (event) => {
    this.setState({month: event.target.value}, this._onPolyfillChanged);
  };

  _onNativeChanged = (event) => {
    this.props.onChange(event.target.value);
  };

  _onPolyfillChanged = () => {
    const d = new Date(parseInt(this.state.year, 10), parseInt(this.state.month, 10) - 1, parseInt(this.state.day, 10));
    if (!isNaN(d.getTime())) {
      this.props.onChange([
        _padLeft(String(d.getFullYear()), 4, '0'),
        _padLeft(String(d.getMonth() + 1), 2, '0'),
        _padLeft(String(d.getDate()), 2, '0'),
      ].join('-'));
    } else if (this.props.value !== '') {
      this.props.onChange('');
    }
  };

  _onYearChanged = (event) => {
    this.setState({year: event.target.value}, this._onPolyfillChanged);
  };

  state = this._parseValue(this.props.value);

  render() {
    if (Modernizr.inputtypes.date && !this.props.forceFallback) {
      return (
        <input
          type="date"
          className="form-control"
          min={this.props.min}
          max={this.props.max}
          value={this.props.value}
          onChange={this._onNativeChanged}
          disabled={this.props.disabled}
          readOnly={this.props.readOnly}
          required={this.props.required}
        />
      );
    }
    let dayOptions = [];
    for (let i = 1; i <= 31; i++) {
      let str = _padLeft(i, 2, '0');
      dayOptions.push(
        <option key={i} value={str}>{str}</option>
      );
    }
    let yearOptions = [];
    let minYear = 1900;
    if (this.props.min) {
      minYear = parseInt(this.props.min.slice(0, 4), 10);
      if (isNaN(minYear)) {
        minYear = 1900;
      }
    }
    let maxYear = (new Date()).getFullYear();
    if (this.props.max) {
      maxYear = parseInt(this.props.max.slice(0, 4), 10);
      if (isNaN(maxYear)) {
        maxYear = (new Date()).getFullYear();
      }
    }
    for (let i = maxYear; i >= minYear; i--) {
      let str = _padLeft(i, 4, '0');
      yearOptions.push(
        <option key={i} value={str}>{str}</option>
      );
    }
    if (this.props.minYearFirst) {
      yearOptions.reverse();
    }
    return (
      <div className="DateInputFallback">
        <SelectInput className="form-control DateInputFallback-mm" placeholder="MM" value={this.state.month} onChange={this._onMonthChanged} disabled={this.props.disabled} readOnly={this.props.readOnly} required={this.props.required}>
          <option value="">MM</option>
          <option value="01">Jan</option>
          <option value="02">Feb</option>
          <option value="03">Mar</option>
          <option value="04">Apr</option>
          <option value="05">May</option>
          <option value="06">Jun</option>
          <option value="07">Jul</option>
          <option value="08">Aug</option>
          <option value="09">Sep</option>
          <option value="10">Oct</option>
          <option value="11">Nov</option>
          <option value="12">Dec</option>
        </SelectInput>
        <SelectInput className="form-control DateInputFallback-dd" placeholder="DD" value={this.state.day} onChange={this._onDayChanged} disabled={this.props.disabled} readOnly={this.props.readOnly} required={this.props.required}>
          <option value="">DD</option>
          {dayOptions}
        </SelectInput>
        <SelectInput className="form-control DateInputFallback-yyyy" placeholder="YYYY" value={this.state.year} onChange={this._onYearChanged} disabled={this.props.disabled} readOnly={this.props.readOnly} required={this.props.required}>
          <option value="">YYYY</option>
          {yearOptions}
        </SelectInput>
      </div>
    );
  }
}

export default DateInput;
